// extracted by mini-css-extract-plugin
export var body = "_2i-1";
export var bodyPadded = "_2i-2";
export var chevron = "_2i-4";
export var chevronOpen = "_2i-5";
export var header = "_2i-0";
export var icon = "_2i-3";